import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import InterventionTemplatesTable from "@/components/ListTable/InterventionTemplatesTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { INTERVENTION_TEMPLATES_FILTERS } from "@/entities/intervention-templates";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import InterventionTemplateAddButton from "@/modules/intervention-template/intervention-template-add-button";
import { ListProvider } from "@/modules/list";

const InterventionTemplates = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader
        title={t("global:interventionTemplatePlural")}
        extra={[
          <InterventionTemplateAddButton key="intervention-template-add-button" />,
        ]}
      />
      <AppLayoutPage>
        <ListProvider
          endpoint="interventionTemplates"
          storageKey={STORAGE_KEYS.INTERVENTION_TEMPLATES}
          hiddenFilters={{ [INTERVENTION_TEMPLATES_FILTERS.LATEST]: true }}
        >
          <InterventionTemplatesTable />
        </ListProvider>
      </AppLayoutPage>
    </>
  );
};

export default InterventionTemplates;
